<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';
import ConversationApi from 'dashboard/api/inbox/conversation';

const props = defineProps({
  conversation: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();
const teams = useMapGetter('teams/getTeams');

const conversationId = computed(
  () => props.conversation?.id || props.conversation?.displayId
);

const contactId = computed(
  () =>
    props.conversation?.meta?.sender?.id ||
    props.conversation?.contactId ||
    props.conversation?.contact_id
);

const hasAssignedTeam = computed(() => Boolean(props.conversation?.meta?.team));

const teamsList = computed(() => {
  if (hasAssignedTeam.value) {
    return [
      { id: 0, name: t('TEAMS_SETTINGS.LIST.NONE') },
      ...(teams.value || []),
    ];
  }
  return teams.value || [];
});

const assignedTeam = computed(() => props.conversation?.meta?.team || null);

const onAssignTeam = async team => {
  const teamId = team ? team.id : 0;
  try {
    await ConversationApi.assignTeam({
      conversationId: conversationId.value,
      teamId,
    });
    if (contactId.value) {
      await store.dispatch('contactConversations/get', contactId.value);
    }
    useAlert(t('CONVERSATION.CHANGE_TEAM'));
  } catch (_e) {
    useAlert(
      t('COMPOSE_NEW_CONVERSATION.FORM.TEAM_ACCESS_ERROR') ||
        t('COMPOSE_NEW_CONVERSATION.FORM.ERROR_MESSAGE')
    );
  }
};
</script>

<template>
  <div class="px-2 pb-3 flex flex-col gap-1" @click.stop>
    <p class="text-xs font-medium text-n-slate-11 px-1">
      {{ t('CONVERSATION_SIDEBAR.TEAM_LABEL') }}
    </p>
    <MultiselectDropdown
      :options="teamsList"
      :selected-item="assignedTeam"
      :multiselector-title="t('AGENT_MGMT.MULTI_SELECTOR.TITLE.TEAM')"
      :multiselector-placeholder="t('AGENT_MGMT.MULTI_SELECTOR.PLACEHOLDER')"
      :no-search-result="t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.NO_RESULTS.TEAM')"
      :input-placeholder="
        t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.PLACEHOLDER.TEAM')
      "
      @select="onAssignTeam"
    />
  </div>
</template>
